/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";
import dateUtils from "utils/date";

const PaymentGatewaysTable = ({
  paymentGateways,
  companyURL,
  onClickDelete
}) => {
  const TableOrNotFound = () => {
    if (paymentGateways.loading) {
      return "is Loading";
    }
    if (isEmpty(paymentGateways.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Enabled</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {paymentGateways.data.map(paymentGateway => (
            <tr key={paymentGateway.id}>
              <td>{paymentGateway.id}</td>
              <td>{paymentGateway.gateway.title}</td>
              <td>{paymentGateway.enabled}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/${companyURL}/payment-gateways/${paymentGateway.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Update</span>
                  </Link>
                  <a
                    onClick={onClickDelete(paymentGateway.id)}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};
export default PaymentGatewaysTable;
